<template>
	<div class="backdrop">
		<transition name="fade" appear>
			<div :class="['signin', loading ? 'loading' : '']" @keyup.enter="signin">
				<preloader skin="blue" v-if='!!loading'></preloader>
				<div class="center-msg" v-else-if="forgotSuccess">
					<i class="fal fa-paper-plane fa-3x"></i>
					<h3 class="text-green-3 my-xl">
						An email has been sent to reset your password
					</h3>
					<h5>please click the <strong>reset link.</strong></h5>
				</div>
				<div class="center-msg" v-else-if="resetSuccess">
					<i class="fal fa-check-circle fa-3x"></i>
					<h3 class="text-green-3 my-xl">
						You password has been changed successfully.
					</h3>
					<a 
						class="blue-link big-link" 
						href="/" @click.prevent="backToLogin">
						<span>Go to sign in</span>
						<i class="fal fa-chevron-right"></i>
					</a>
				</div>
				<div v-else-if="mode==='reset'">
					<h4 class="reset-title">RESET PASSWORD</h4>
					<div :class="['reset', 'form', !!error ? 'error' : '']">
							<div :class="['field', invalid ? 'invalid' : '']">
								<input id="password" v-model="password" type="password"  :class="[password && password.length ? 'valid' : '']">
								<label for="password">Password</label>
							</div>
							<div :class="['field', invalid ? 'invalid' : '']">
								<input id="password2" v-model="password2" type="password"  :class="[password2 && password2.length ? 'valid' : '']">
								<label for="password2">Confirm password</label>
							</div>
							<p class="note">
								Please enter and confirm your new password.
							</p>
						<span v-if="!!error" class="err" v-text="error"></span>
					
					</div>

<vue-recaptcha sitekey="6LebfScaAAAAAOJK0LGkIzulqWi3jMJwW9nJhgck">

					<button :class="['round-btn']" @click="submit"
						v-text="mode==='login' ? 'Login' : 'Submit'"
					></button>
					</vue-recaptcha>
				</div>
				<div v-else>
					<h4>Sign In</h4>
					<div :class="['form', !!error ? 'error' : '']">
						<div :class="['field', invalid ? 'invalid' : '']">
							<input ref="username" @animationstart="autoFillAnimStart" id="username" v-model="user" type="email" :class="[user && user.length ? 'valid' : '']">
							<label for="username">Username</label>
						</div>
						<transition name="fade" mode="out-in" appear>

							<div v-if="mode!=='forgot'" :class="['field', invalid ? 'invalid' : '']">
								<input id="password" v-model="password" type="password"  :class="[password && password.length ? 'valid' : '']">
								<label for="password">Password</label>
							</div>
							<p class="note" v-else>
								Please submit your username, and check your email for a 'reset password' link.
							</p>
						</transition>
						<span v-if="!!error" class="err" v-text="error"></span>
						<p class="captcha-note">
							This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
						</p>
						
					</div>
				<vue-recaptcha sitekey="6LebfScaAAAAAOJK0LGkIzulqWi3jMJwW9nJhgck">

					<button :class="['round-btn', (!user||!password)&&!autofilled ? 'disabled' : '']" @click="submit"
						v-text="mode==='login' ? 'Login' : 'Submit'"
					></button>
				</vue-recaptcha>
				<a
							v-if="mode!=='reset'"
							@click.prevent="mode=(mode==='forgot' ? 'login' : 'forgot')"
							class="psw-link" href="#p" v-text="mode==='forgot' ? 'Nevermind... I remember' : 'Forgot password?' "></a>
				</div>
				
			</div>
		</transition>

	</div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import { mapActions } from 'vuex';
import Preloader from './Preloader.vue'
import axios from 'axios'
export default {
	data() {
		return {
			mode: 'login',
			resetSuccess: false,
			forgotSuccess: false,
			dirty: false,
			user: null,
			password: null,
			password2: null,
			invalid: false,
			autofilled: false,
			error: null,
			loading: false,
		}
	},
	created() {
		let q = this.$route.query;
		// console.log('q > ',q);
		if (q && q.u && q.t) {
			this.mode = 'reset';
		}
		if (!!q && !!_.has(q, 'u') && !!_.has(q, 'p')) {
			let data = {
					u: q.u,
					p: q.p
			}
			this.signInUser(data);
		}
	},
	watch: {
		user() {
			// the valid class ain't changing for some reason...
			if (!this.user) {
				this.$refs.username.classList.remove('valid')
			}
		},
		mode() {
			this.error = false;
		}
	},
	components: {
		Preloader,
		VueRecaptcha
	},
	computed: {
		token() {
			return this.$route.query.t;
		},
		userId() {
			return parseInt(this.$route.query.u);
		}
	},
	methods: {
		...mapActions([
			'signInUser'
		]),
		backToLogin() {
			this.mode = 'login';
			this.resetSuccess = false;
			this.$router.replace('/login')
		},
		
		submit() {
			// console.log("SUBMIT");
			this.error = null;
			this.loading = true;
			if (this.mode==='login') {
				this.signin();
			}
			else if (this.mode==='forgot') {
				this.submitForgot();
			}
			else if (this.mode==='reset') {
				this.submitReset();
			}
			
		},
		submitForgot() {
			let vm = this;
			if (!this.user) {
				this.$set(this, 'invalid', true);
				this.$set(this, 'loading', false);
				setTimeout(function() {
					this.$set(this, 'invalid', false);
				}.bind(this), 1000);
			}
			else {
				var  postURL = "https://api.mis-implants.com/market/UserPasswordReset?e="+this.user;
				return axios.post(postURL).then(response => {
					vm.loading = false;
					if (response.data && response.data == 'ok') {
						vm.forgotSuccess = true;
					}
				}, response => {
						// console.log("err from forogt >> ", response);
						vm.error = "Something went wrong, Please try again.";
				}, {headers: {'Access-Control-Allow-Origin': '*'}})
			}
		},
		submitReset() {
			let vm = this;
			let pass, msg;
			if (this.password) {
				pass = this.password === this.password2;
				msg = 'Your passwords do not match.';
			}
			else if (!this.password || !this.password2) {
				pass = false;
				msg = 'There are fields you need fill.';
			}
			if (!pass) {
				this.$set(this, 'error', msg);
				this.$set(this, 'invalid', true);
				this.$set(this, 'loading', false);
				setTimeout(function() {
					this.$set(this, 'invalid', false);
				}.bind(this), 1000);
				return false;
			}

			// ALL GOOD!
				let postURL = "https://api.mis-implants.com/market/UserPasswordUpdate";
				let p = this.password,
				t = this.token,
				u = this.userId;
				let body = JSON.stringify({ u,t,p })
				console.log('body: ', body);

				return axios.post(postURL, body ).then(response => {
					vm.loading = false;
					// console.log("response from reset >> ", response);
					if (response.data && response.data === 'ok') {
						vm.resetSuccess = true;
					}
					}, response => {
							// console.log("err from reset >> ", response);
							vm.error = "Something went wrong, please try again."
					})
			
		},
		autoFillAnimStart(e) {
			// console.log("auto fill animation started...",e.target.value);
			if (!this.dirty) {
				this.autofilled = true;
				this.dirty = true;
				document.querySelectorAll('input').forEach(f => f.classList.add('valid'))
			}
		},
		async signin() {
			let vm = this;
			
			if (!this.user || !this.password) {
				// console.log("signin missing fields...");
				this.$set(this, 'invalid', true);
				this.$set(this, 'loading', false);
				setTimeout(function() {
					this.$set(this, 'invalid', false);
				}.bind(this), 1000);
			}
			else {
				let data = {
					u: this.user,
					p: this.password
				}
				this.error = await this.signInUser(data);
				if (!!this.error) {
					this.$set(this, 'loading', false);

				}
			}
		}
	}
}

</script>
<style lang="stylus" scoped>

@import '~settings';
@import '~rupture';
	.backdrop
		position absolute 0px 0 0 0
		transform none
		opacity 0.98
		z-index 999999
		+below(815px)
			width 100vw
	.signin
		self-center()
		//top calc(50% - 49px)
		top 50%
		background #fff
		width 440px
		height @width
		border-radius unit(@width/2, 'vmax')
		box-shadow 0 0 22px rgba(0,0,0,0.5)
		padding-top 3.2rem
		+below(815px)
			padding-top 100px
			top 0
			left 0
			bottom 0
			right 0
			width 100vw
			height 100%
			border-radius 0
			transform none
			margin 0
		&.loading
			background rgba(#fff, 0.9)

		h4
			text-align center
			// padding 30px 0 0
			font-size 40px
			color darken(#9e9f9f, 20)
			&.reset-title
				font-size 24px
			+below(815px)
				font-size 22px
		.round-btn
			position absolute false false 12% 50%
			width 68px
			height @width
			text-align center
			border-radius 100%
			color #ffffff
			background #00acec
			text-decoration none
			cursor pointer
			box-shadow inset 0px 0px 4px rgba(255,255,255,0)
			transition background 200ms ease, opacity 200ms ease
			transform translateX(-50%)
			+below(815px)
				position relative
				margin 0 auto
				margin-top 20px
			&:hover
				background darken(#00acec, 5)
				color #fff
				outline none
			&.disabled
				opacity 0.6
.form
	self-center()
	top 50%
	width 60%
	+below(815px)
		position relative
		transform none
		top initial
		left initial
		width 70vw
		margin auto
		margin-top 70px
	.err
		color lighten(red, 30)
		font-size 12px
		text-align center
		padding 5px 0 0 0
		display inline-block
		position absolute

.field
	position relative
	margin-bottom 40px
	&:last-of-type
		margin 0
	input
		border 0
		border-bottom 1px solid lighten(lightgray, 2)
		height 36px
		width 100%
		border-radius 0
		&:focus, &:active
			outline 0
	label
		position absolute
		font-size 16px
		left 0
		top 50%
		transform translate(0, -10px)
		color lighten(lightgray, 2)
		transition font-size 300ms ease, transform 300ms ease, color 300ms ease
	input:focus,
	input.valid
		border-color lighten(darkblue, 20)
		& + label
			color darken(lightgray, 25)
			font-size 12px
			transform translate(0, -40px)
			&:after
				content ':'
	&.invalid
		input:not(.valid)
			animation blink 700ms infinite ease-in-out;
.error
	.field input
		border-color lighten(red, 30)


@keyframes blink {
	0% {
		border-color lighten(red, 30)
	}
	90% {
		border-color lighten(lightgray, 2)
	}

}



// CHROM AUTOFILL HACK
@keyframes onAutoFillStart {
	from {
		border-color lighten(red, 30)
	}
	to {
		border-color lighten(lightgray, 2)
	}
}
@keyframes onAutoFillCancel {
	from {
		border-color lighten(red, 30)

		}
	to {
		border-color lighten(lightgray, 2)

	}
}
input:-webkit-autofill {
    // Expose a hook for JavaScript when autofill is shown
    // JavaScript can capture 'animationstart' events
    animation-name: onAutoFillStart;
	-webkit-box-shadow: 0 0 0 30px lighten(blue, 43) inset;
    // Make the background color become yellow really slowly
    transition: background-color 1s ease-in-out 0s;
}
input:not(:-webkit-autofill) {
    // Expose a hook for JS onAutoFillCancel
    // JavaScript can capture 'animationstart' events
    animation-name: onAutoFillCancel;
}
</style>
<style lang="stylus">
.reset .note
	margin-top 20px
.center-msg
	display flex
	flex-direction column
	align-items center
	justify-content center
	height 100%
	max-width 80%
	text-align center
	margin 0 auto
	& > i
		display block
		margin-bottom 20px
		color darken(lightblue, 20)
		font-size 60px
	strong
		font-weight 600
	line-height 1.5
.note
	margin 10px 0
	font-size 13px
.psw-link
	display block
	// margin-top 28px
	position absolute
	bottom 7%
	left 50%
	transform translateX(-50%)
	color darken(lightblue, 20) !important
	font-size 13px
.big-link
	margin 20px 0
	font-size 16px
	display flex
	flex-direction row
	flex-wrap nowrap
	justify-content center
	align-items baseline
	line-height 1
	i
		margin-left 5px
.blue-link
	color darken(lightblue, 20) !important

.signin
	.preloader
		img
			opacity 0.8
		h5
			color #fff
			opacity 0.8

.grecaptcha-badge
	visibility hidden
.captcha-note
	margin 10px 0
	font-size 11px
	a
		color darken(lightblue, 20) !important
		
</style>